

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Dashboard PRO Material-UI components
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";

// Dashboard PRO Material-UI example components
import TimelineItem from "examples/Timeline/TimelineItem";

function OrdersOverview() {
  return (
    <Card className="h-100">
      <DSBox pt={3} px={3}>
        <DSTypography variant="h6" fontWeight="medium">
          Promotions
        </DSTypography>
        <DSBox mt={1} mb={2}>
          <DSTypography variant="button" textColor="text" fontWeight="regular">
            <DSTypography display="inline" variant="body2" verticalAlign="middle">
              <Icon className="font-bold text-success">arrow_upward</Icon>
            </DSTypography>
            &nbsp;
            <DSTypography variant="button" textColor="text" fontWeight="medium">
              24%
            </DSTypography>{" "}
            this month
          </DSTypography>
        </DSBox>
      </DSBox>
      <DSBox p={2}>
        <TimelineItem
          color="success"
          icon="hourglass_empty"
          title="NYE"
          dateTime="31 DEC 7:20 PM"
        />
        <TimelineItem
          color="error"
          icon="landscape"
          title="B1G1"
          dateTime="21 DEC 11 PM"
        />
        <TimelineItem
          color="error"
          icon="hotel_class"
          title="Mega Christmas"
          dateTime="24 DEC 9:34 PM"
        />
        
        <TimelineItem
          color="primary"
          icon="rocket_launch"
          title="Rocket Deals"
          dateTime="18 DEC 4:54 AM"
        />
        <TimelineItem
          color="warning"
          icon="payment"
          title="10% Cashback on VM"
          dateTime="10 DEC 2:20 AM"
        />
        <TimelineItem color="dark" icon="person_add" title="20% Off New Users" dateTime="17 DEC" />
      </DSBox>
    </Card>
  );
}

export default OrdersOverview;
